module.exports = __webpack_public_path__ + "img/left-lightning7.6fe7f5ca.png";